import { HasPermission } from '@shared/components';
import { Outlet } from 'react-router-dom';

export const FilesReports = () => {
  return (
    <HasPermission permissionFeature="REPORTS_FILES" permissionType="READ" redirect>
      <Outlet />
    </HasPermission>
  );
};
